module.exports = __webpack_public_path__ + "img/green-tick.e9c9ba3c.svg";